import React from 'react';
import { Provider } from 'react-redux';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Routes from './Routes';
import type { AppStore } from '../../store/configureStore';
import Application from '../Application';

// Use the history type react-router's HistoryRouter expects (its bundled History
// differs from the `history` package's — createURL/encodeLocation).
interface RootProps {
  history: React.ComponentProps<typeof HistoryRouter>['history'];
  // Built in index.tsx: the store must be created after the redirect callback
  // writes the session, and calling configureStore() in JSX rebuilt it per render.
  store: AppStore;
}

const Root = ({ history, store }: RootProps) => (
  <Provider store={store}>
    <div>
      <HistoryRouter history={history}>
        <Application/>
        <Routes/>
        <ToastContainer
          autoClose={3000}
          position="top-right" />
      </HistoryRouter>
    </div>
  </Provider>
);

export default Root;
